import { faClock } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { getCommentUser } from '../../Api/ClientServices'
import Style from './CommentList.module.css'
import ReactLoading from 'react-loading';
import { faCheck, faCheckDouble } from '@fortawesome/free-solid-svg-icons'
const CommentList = () => {
    const [comment,setComment]=useState()
    useEffect(()=>{
        getComment()
    },[window.location.pathname])

    const getComment=async()=>{
        const data=await getCommentUser(window.location.pathname.split('/')[3])
        setComment(data.comments)
    }
    let loadingHandler=null
    if(comment===undefined){
        loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
        <ReactLoading type={'cylon'} color={'#096CCC'} />
      </div>
    }
    else{
        loadingHandler=comment.slice(0).reverse().map(item=>{
            return(
                <div key={item.id} className={Style.CommentPart}>
                    <div className={Style.TopDivisionComment}>
                        <h3><FontAwesomeIcon icon={faClock}/>  {item.date}</h3>
                        {item.status==='0'?<FontAwesomeIcon icon={faCheck} color='gray'/>:<FontAwesomeIcon icon={faCheckDouble} color='#1565CB'/>}
                        
                    </div>
                    <p>{item.message}</p>
                    {item.cr_message===null?null:<p className={Style.AnswerHolder}>{item.cr_message}</p>}
                </div>
            )
        })
    }
    return (
        <>
        {
            loadingHandler
        }
        </>

    )
}

export default CommentList
